/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from "react";

export default function CTraderOnboardingModal({
  open,
  onClose,
  loading,
  error,
  accounts,
  onSelect,
  onRetry,
  status,
}) {
  if (!open) return null;
  const waiting = ["starting", "awaitingPopup", "awaitingTempId"].includes(status);
  const selecting = status === "selecting";
  const noAccounts = selecting && (!accounts || accounts.length === 0);
  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50">
      <div className="bg-backgroundSurface border border-borderDefault rounded-lg shadow-xl w-[520px] max-w-[92vw]">
        <div className="px-4 py-3 border-b border-borderDefault flex items-center justify-between">
          <h3 className="text-base font-semibold text-textPrimary">Link your cTrader account</h3>
          <button onClick={onClose} className="text-textSecondary hover:text-textPrimary">✕</button>
        </div>
        <div className="p-4 space-y-3">
          {waiting && (
            <div className="text-textSecondary text-sm">Waiting for authorization… Please complete the cTrader login in the popup.</div>
          )}
          {loading && (
            <div className="text-textSecondary text-sm">Loading your cTrader accounts…</div>
          )}
          {error && (
            <div className="text-red-500 text-sm">{error.message || String(error)}</div>
          )}
          {!waiting && !loading && !error && noAccounts && (
            <div className="text-textSecondary text-sm">No cTrader accounts found for this user.</div>
          )}
          {!waiting && !loading && !error && accounts && accounts.length > 0 && (
            <ul className="max-h-72 overflow-auto divide-y divide-borderDefault">
              {accounts.map((acc) => {
                const id = acc.ctidTraderAccountId || acc.ctrader_account_id || acc.accountId || acc.id;
                const broker = acc.brokerName || acc.broker || "";
                const env = (acc.environment || acc.type || "").toString().toUpperCase();
                const name = acc.displayName || `Account ${id}`;
                return (
                  <li key={String(id)} className="py-2 flex items-center justify-between gap-2">
                    <div className="min-w-0">
                      <div className="text-textPrimary text-sm font-medium truncate">{name}</div>
                      <div className="text-textSecondary text-xs truncate">{env} · {broker}</div>
                    </div>
                    <button
                      type="button"
                      onClick={() => onSelect(acc)}
                      className="btn btn-primary btn-sm shrink-0"
                      disabled={status === "completing"}
                    >Select</button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        <div className="px-4 py-3 border-t border-borderDefault flex items-center justify-end gap-2">
          {error ? (
            <button className="btn btn-secondary" onClick={onRetry}>Retry</button>
          ) : (
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          )}
        </div>
      </div>
    </div>
  );
}
